/** Shared helpers of the reference markup for the poker cluster (teen8 / poker / poker6). */

// Reference v-kvalmin / v-kvalmax: 1000 → "1K", 100000 → "1L"
export function formatRangeVal(val) {
  const n = Number(val);
  if (val == null || val === "" || Number.isNaN(n)) return "";
  if (n >= 100000) return `${parseFloat((n / 100000).toFixed(2))}L`;
  if (n >= 1000) return `${parseFloat((n / 1000).toFixed(2))}K`;
  return String(parseFloat(n.toFixed(2)));
}

// Reference v-casinofancybook / v-casinobook: amount > 0 → book-green, otherwise book-red
export const bookClass = (exp) => (Number(exp) > 0 ? "book-green" : "book-red");

export const isOpen = (m) => String(m?.gstatus || "").toUpperCase() === "OPEN";

// Markets sorted by sr, like the reference's orderBy(sub, "sr")
export const bySr = (list) =>
  [...(Array.isArray(list) ? list : [])].sort((a, b) => Number(a?.sr) - Number(b?.sr));

export function getExposureFrom(exposures, name) {
  if (!name) return 0;
  const v = exposures?.[name] ?? exposures?.[String(name).toLowerCase()];
  return v != null ? Number(v) || 0 : 0;
}
